import { localeFromPath, localePath, normalizeLocale } from "./localeRouting.js";

const PARAMS = {
  query: "q",
  searchLanguage: "search_lang",
  documentType: "document_type",
  year: "year_be",
  navigationMode: "mode",
  workId: "work_id",
  expressionId: "expression_id",
  readerMode: "doc_lang",
  parallelSide: "parallel_side",
  uiLanguage: "ui_lang",
  asOfDate: "as_of_date",
};

export function readReaderUrlState(location = window.location) {
  const params = new URLSearchParams(location.search);
  const hash = new URLSearchParams(location.hash.replace(/^#/, ""));
  const state = Object.fromEntries([
    ...Object.entries(PARAMS).map(([key, name]) => [key, params.get(name) || ""]),
    ["provisionId", hash.get("provision") || ""],
  ]);
  if (!state.uiLanguage) state.uiLanguage = localeFromPath(location.pathname || "");
  return state;
}

export function writeReaderUrlState(patch, { push = false } = {}) {
  const url = new URL(window.location.href);
  for (const [key, name] of Object.entries(PARAMS)) {
    if (!(key in patch)) continue;
    const value = patch[key];
    if (value == null || value === "") url.searchParams.delete(name);
    else url.searchParams.set(name, String(value));
  }
  if ("uiLanguage" in patch) {
    url.pathname = localePath(normalizeLocale(patch.uiLanguage), url.pathname);
    url.searchParams.delete("ui_lang");
  }
  if ("provisionId" in patch) {
    const hash = new URLSearchParams(url.hash.replace(/^#/, ""));
    const value = patch.provisionId;
    if (value) hash.set("provision", String(value));
    else hash.delete("provision");
    url.hash = hash.toString();
  }
  window.history[push ? "pushState" : "replaceState"]({}, "", url);
}
